import { render, staticRenderFns } from "./AddFeeDialog.vue?vue&type=template&id=6c453820&scoped=true"
import script from "./AddFeeDialog.vue?vue&type=script&lang=js"
export * from "./AddFeeDialog.vue?vue&type=script&lang=js"
import style0 from "./AddFeeDialog.vue?vue&type=style&index=0&id=6c453820&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c453820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c453820')) {
      api.createRecord('6c453820', component.options)
    } else {
      api.reload('6c453820', component.options)
    }
    module.hot.accept("./AddFeeDialog.vue?vue&type=template&id=6c453820&scoped=true", function () {
      api.rerender('6c453820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/components/AddFeeDialog.vue"
export default component.exports